"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestAuthProvider = GuestAuthProvider;
const react_1 = __importStar(require("react"));
const context_1 = require("../context");
/**
 * Load a guest session from the server
 */
function useGuestSession() {
    const [guestId, setGuestId] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        function get() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield fetch(APP_API_URL + "/guest/session", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                if (!response.ok) {
                    setLoading(false);
                    setError("Failed to create guest session");
                    return;
                }
                const { id } = yield response.json();
                setGuestId(id);
                setLoading(false);
            });
        }
        get();
    }, []);
    const session = (0, react_1.useMemo)(() => ({ id: guestId }), [guestId]);
    return {
        error,
        loading,
        session,
    };
}
function GuestAuthProvider({ children }) {
    const { session, loading, error } = useGuestSession();
    const account = (0, react_1.useMemo)(() => ({
        type: "guest",
        id: (session === null || session === void 0 ? void 0 : session.id) || "",
        nickname: "Guest " + ((session === null || session === void 0 ? void 0 : session.id) || ""),
    }), [session]);
    if (error || loading || !session) {
        return null;
    }
    return (react_1.default.createElement(context_1.AccountContextProvider, { value: account }, children));
}
